<div *ngIf="!job"><mat-spinner diameter="50"></mat-spinner></div>
<div *ngIf="job">
	<div mat-dialog-content>
		<rpfsa-job-details-card
			*ngIf="job"
			fxLayout="row"
			[job]="job"
		></rpfsa-job-details-card>
	</div>
	<div mat-dialog-actions fxLayout="row" fxLayoutAlign="center">
		<button
			mat-raised-button
			fxFlex="50"
			fxFill
			type="button"
			color="primary"
			[matDialogClose]
			[routerLink]="jobsFragments.detail(job.id)"
			routerLinkActive="router-link-active"
		>
			VIEW
		</button>
		<button
			mat-button
			fxFlex="50"
			fxFill
			type="button"
			color="primary"
			[matDialogClose]
			[routerLink]="jobsFragments.assignments(job.id)"
			[queryParams]="{ sd: startDate }"
			routerLinkActive="router-link-active"
		>
			SCHEDULE FIELD WORKER
		</button>
	</div>
</div>
